import { msg } from '@lingui/core/macro';
import type { PlaceholderCategory } from 'modules/template-editor/domain/utils/placeholder-categories';
import type { MessageDescriptor } from 'shared/i18n/i18n';

interface ICategory {
  label: MessageDescriptor;
  value: PlaceholderCategory;
}

export const categoryList: ICategory[] = [
  {
    label: msg`Обычные`,
    value: 'common',
  },
  {
    label: msg`Составные`,
    value: 'complex',
  },
  {
    label: msg`События`,
    value: 'events',
  },
  {
    label: msg`Карусель`,
    value: 'carousel',
  },
];
